import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid " }
const _hoisted_2 = { class: "p-field  p-float-label" }
const _hoisted_3 = {
  for: "url",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-field  p-float-label" }
const _hoisted_5 = {
  for: "type",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock("form", _hoisted_1, [
    _createVNode("span", _hoisted_2, [
      _createVNode(_component_InputText, {
        id: "url",
        class: "kn-material-input",
        type: "text",
        modelValue: _ctx.myData.jsonActionParameters.contextBrokerUrl,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.myData.jsonActionParameters.contextBrokerUrl = $event))
      }, null, 8, ["modelValue"]),
      _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('kpi.alert.brokerUrl')) + " * ", 1)
    ]),
    _createVNode("span", _hoisted_4, [
      _createVNode(_component_InputText, {
        id: "type",
        class: "kn-material-input",
        type: "text",
        modelValue: _ctx.myData.jsonActionParameters.contextBrokerType,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.myData.jsonActionParameters.contextBrokerType = $event))
      }, null, 8, ["modelValue"]),
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('kpi.alert.brokerType')) + " * ", 1)
    ])
  ]))
}